/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "E:/mobile_v2/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Marquee from 'vux/src/components/marquee/marquee';
import MarqueeItem from 'vux/src/components/marquee/marquee-item';
export default {
  name: 'Index',
  components: {
    Marquee: Marquee,
    MarqueeItem: MarqueeItem
  },
  data: function data() {
    return {
      navData: [],
      navTopData: [],
      messageList: [],
      newsHandler: '',
      newsFlag: 0,
      msgLen: 6,
      title: '',
      headFlag: '0',
      firstLogin: 1,
      navshow: false
    };
  },
  computed: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    //在next中写处理函数
    next(function (vm) {
      return vm.wherefrom(from.name);
    });
  },
  watch: {
    navData: function navData() {
      this.$nextTick(function () {
        var Module = this.navData.some(function (item) {
          // 判断项应为获取的变量
          if (item.iconUrlId == '/multistageApproval') {
            return true;
          }
        });
        var num = this.$utils.Store.getItem('firstLogin'); //首次登录并且多级审批模块存在

        if (Module && num == 1) {
          this.navshow = true; //执行新手引导

          this.noviceGuidance();
        } else {
          this.cancelNav();
        }
      });
    }
  },
  methods: {
    wherefrom: function wherefrom() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.firstLogin = _this.$utils.Store.getItem('firstLogin');
                _context.next = 3;
                return _this.getHomeMenu();

              case 3:
                _context.next = 5;
                return _this.getAuth();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //新手引导(多级审批)
    noviceGuidance: function noviceGuidance() {
      var bootModule = document.getElementById('/multistageApproval');
      var Itemtop = bootModule.getBoundingClientRect().bottom; //获取dom对象底边与顶部距离

      var Itemleft = bootModule.getBoundingClientRect().left; //获取dom对象左边距离左边的距离

      var Itemwidth = bootModule.offsetWidth; //width+border+padding 实际的宽度

      var GuideBox = document.getElementById('IndexGuideBox'); //获取蒙版dom对象

      var navBoxTop = document.getElementsByClassName('nav-box-top'); //获取小圆圈以及竖线 外边的dom对象

      var Item = document.getElementsByClassName('van-grid-item__content');
      bootModule.style.background = 'transparent'; //高亮背景颜色

      bootModule.style.zIndex = '502'; //蒙版是501  高出蒙版就可以显示蒙版上层

      bootModule.style.border = '1px dashed #fff'; //添加边框

      bootModule.style.padding = '0.04rem'; //边框与内容有个内边距

      bootModule.style.borderRadius = ' 0.06rem'; //边框圆角弧度

      GuideBox.style.top = parseInt(Itemtop) + 'px';
      navBoxTop[0].style.left = parseInt(Itemleft) + parseInt(Itemwidth / 2, 10) + 'px';

      for (var i = 0; i < Item.length; i++) {
        Item[i].style.borderRadius = '0.04rem';
      }
    },
    cancelNav: function cancelNav() {
      this.navshow = false;
      this.$utils.Store.setItem('firstLogin', 0);
      this.$utils.Store.setItem('nav', 0);
      this.firstLogin = 0;
    },
    nextNav: function nextNav() {
      this.$utils.Store.setItem('nav', 1);
      this.$router.push({
        path: '/multistageApproval',
        query: {
          nav: 1
        }
      });
    },
    newsTitle: function newsTitle(value) {
      return value.length > 13 ? value.substring(0, 12) + '…' : value;
    },
    indexnavClick: function indexnavClick(value) {
      var _this2 = this;

      if (value === '' || value === null) {
        this.$utils.Tools.toastShow('功能暂未开放');
      } else {
        setTimeout(function () {
          _this2.$router.push(value);
        }, 100);
      }
    },
    navClick: function navClick(value) {
      var _this3 = this;

      if (value === '' || value === null) {
        this.$utils.Tools.toastShow('功能暂未开放');
      } else {
        setTimeout(function () {
          _this3.$router.push(value);
        }, 100);
      }
    },
    getMesageLen: function getMesageLen() {
      var _this4 = this;

      return this.$api.Sys.getSystemParams(0, this.$constant.msgShowLen).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this4.$code.success) {
          _this4.$utils.Tools.toastShow(msg);
        } else {
          if (data === null) {
            return 3;
          } else {
            _this4.msgLen = +data.paramValue;
            return data.paramValue;
          }
        }
      }).catch(function () {
        _this4.$utils.Tools.httpError();

        return Promise.reject();
      });
    },
    getMesageData: function getMesageData(len) {
      var _this5 = this;

      this.$api.Message.getMessageData({
        pageIndex: 1,
        pageSize: 10,
        search: {
          userSerial: this.$utils.Store.getItem('userSerial')
        }
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this5.$code.success) {
          _this5.$utils.Tools.toastShow(msg);
        } else {
          _this5.messageList = data.records;

          if (_this5.messageList.length === 0) {
            _this5.newsFlag = 0;
          } else if (_this5.messageList.length <= len) {
            _this5.newsFlag = 1;
          } else {
            _this5.newsFlag = 2;
          }
        }
      }).catch(function () {
        _this5.$utils.Tools.httpError();
      });
    },
    moreClick: function moreClick() {
      this.$router.push('/AllPrograms');
    },
    //档案管理
    fileList: function fileList() {
      this.$router.push('/fileList');
    },
    //入职档案
    InductionInfo: function InductionInfo() {
      this.$router.push('/InductionInfo');
    },
    mesageClick: function mesageClick() {
      this.$router.push('/MessageList');
    },
    getHomeMenu: function getHomeMenu() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.$utils.Tools.loadShow();

                _context2.next = 3;
                return _this6.$api.Home.getHomeMenu({
                  companyId: 0,
                  userId: _this6.$utils.Store.getItem('userSerial'),
                  spareCol1: 1,
                  spareCol2: 0
                }).then(function (response) {
                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (+code !== _this6.$code.success) {
                    _this6.$utils.Tools.loadHide();

                    _this6.$utils.Tools.toastShow(msg);
                  } else {
                    _this6.navData = data;

                    _this6.$utils.Store.setLocalItem('menuIndex', JSON.stringify(data));

                    _this6.$utils.Tools.loadHide(); // this.noviceGuidance()

                  }
                }).catch(function () {
                  _this6.$utils.Tools.httpError();
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 获取用户外勤打卡权限
    getAuth: function getAuth() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.$utils.Tools.loadShow();

                _context3.next = 3;
                return _this7.$api.Home.getUserAuth(_this7.$utils.Store.getItem('userSerial')).then(function (response) {
                  var code = response.code;

                  if (+code !== _this7.$code.success) {
                    _this7.$utils.Tools.loadHide();

                    _this7.navData = _this7.navData.filter(function (item) {
                      return item.menuName !== "外勤考勤";
                    });
                  } else {
                    _this7.$utils.Tools.loadHide();
                  }
                }).catch(function () {
                  _this7.$utils.Tools.httpError();
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getHomeTopMenu: function getHomeTopMenu() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8.$utils.Tools.loadShow();

                _context4.next = 3;
                return _this8.$api.Home.getHomeMenu({
                  companyId: 0,
                  userId: _this8.$utils.Store.getItem('userSerial'),
                  spareCol1: 0,
                  spareCol2: 0
                }).then(function (response) {
                  var code = response.code,
                      msg = response.msg,
                      data = response.data;

                  if (+code !== _this8.$code.success) {
                    _this8.$utils.Tools.loadHide();

                    _this8.$utils.Tools.toastShow(msg);
                  } else {
                    _this8.navTopData = data;

                    if (_this8.navTopData && _this8.navTopData.length > 0) {
                      _this8.headFlag = '1';
                    } else {
                      _this8.headFlag = '2';
                    }

                    _this8.$utils.Store.setLocalItem('menuTopIndex', JSON.stringify(data));

                    _this8.$utils.Tools.loadHide();
                  }
                }).catch(function () {
                  _this8.$utils.Tools.httpError();
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    pushHistory: function pushHistory() {
      var state = {
        title: 'title',
        url: ''
      };
      window.history.pushState(state, state.title, state.url);
    },
    initData: function initData() {
      // this.$utils.Store.removeItem('init');
      this.$utils.Store.removeItem('longitude');
      this.$utils.Store.removeItem('latitude');
      this.$utils.Store.removeItem('address');
      this.$utils.Store.removeItem('typeList');
    }
  },
  created: function created() {
    var _this9 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this9.$api.Sys.getSysSetting().then(function (res) {
                _this9.title = res.title;
              });

              _this9.initData();

              _this9.navData = JSON.parse(_this9.$utils.Store.getLocalItem('menuIndex')) || [];
              _this9.navTopData = JSON.parse(_this9.$utils.Store.getLocalItem('menuTopIndex'));
              _context5.next = 6;
              return _this9.getHomeMenu();

            case 6:
              _context5.next = 8;
              return _this9.getHomeTopMenu();

            case 8:
              _this9.getMesageLen().then(_this9.getMesageData);

              _context5.next = 11;
              return _this9.getAuth();

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {}
};